import React from "react"
import { Box, Flex } from "@theme-ui/components"
import { InboundLink } from "./link"
import { changeAriaboxFontToOrbitron } from "../utils/fontChanger"
import {
  getHomePath,
  getPagePath,
} from "../utils/path"

const Breadcrumbs = ({ page }) => {

  function renderSwitch(page) {
    return <PageBreadcrumbs page={page} />
  }

  const PageBreadcrumbs = ({ page }) => (
    <List>
      <Item>
        <InboundLink color="light" to={getHomePath(page.locale)}>Home</InboundLink>
      </Item>
      {page.treeParent && page.treeParent.treeParent && (
        <Item>
          <InboundLink to={getPagePath(page.treeParent.treeParent)}>
            {page.treeParent.treeParent.title ||
              page.treeParent.treeParent.name}
          </InboundLink>
        </Item>
      )}
      {page.treeParent && (
        <Item>
          <InboundLink to={getPagePath(page.treeParent)}>{page.treeParent.title}</InboundLink>
        </Item>
      )}
      <Item>
        <Box dangerouslySetInnerHTML={{ __html: changeAriaboxFontToOrbitron(page.title) }} />
      </Item>
    </List>
  )

  return renderSwitch(page)
}

const List = props => {
  return (
    <Flex
      {...props}
      sx={{
        flexDirection: "row",
        margin: 0,
        padding: 0,
        listStyle: "none",
        color: "light",
        fontSize: [1],
        fontWeight: "bold",
        letterSpacing: "2.5px",
        a: {
          fontSize: [1],
          fontWeight: "bold",
          textDecoration: "none",
          "&:hover": {
            textDecoration: "underline",
          },
        },
      }}
      as="ul"
    />
  )
}

const Item = props => {
  return (
    <Box
      {...props}
      sx={{
        marginRight: 2,
        "&::after": {
          content: '"|"',
          marginLeft: 2,
          display: ["inline"],
        },
        "&:last-child": {
          marginRight: 0,
          "&::after": {
            display: "none",
          },
        },
      }}
      as="li"
    />
  )
}

export default Breadcrumbs
